import React from 'react';
import AgentPortalStreamlined from 'components/agent-portal/AgentPortalStreamlined';

const AgentPortal = () => {
  return <AgentPortalStreamlined />;
};

export default AgentPortal;